<div
  class="lm-root"
  [class.lm-mobile]="isMobileUi"
  [class.lm-mobile-people-open]="isMobileUi && mobilePanel === 'people'"
  [class.lm-mobile-stream-open]="isMobileUi && mobilePanel === 'stream'"
  [class.lm-mobile-stream-active]="isMobileUi && mobilePanel === 'stream' && (mode === 'single' || (mode === 'patrol' && patrolRunning))"
  *ngIf="stats$ | async as st">
  <div class="lm-header">
    <div class="lm-title">
      <div class="lm-mobile-title-row" *ngIf="isMobileUi">
        <div class="lm-title-text">Live Monitoring</div>
        <button
          *ngIf="mobilePanel === 'stream'"
          type="button"
          class="lm-pick-employee-btn"
          (click)="setMobilePanel('people')">
          <span class="material-symbols-outlined" aria-hidden="true">group</span>
          <span>Employees</span>
          <span class="lm-pick-employee-count">{{ filteredEmployees.length }}</span>
        </button>
        <button
          *ngIf="mobilePanel === 'people'"
          type="button"
          class="lm-back-stream-btn"
          (click)="setMobilePanel('stream')">
          <span class="material-symbols-outlined" aria-hidden="true">arrow_back</span>
          <span>Desktop stream</span>
        </button>
      </div>
      <ng-container *ngIf="!isMobileUi">
        <div class="lm-title-text">Live Monitoring</div>
        <div class="lm-subtitle">Real-time screen viewing workspace</div>
      </ng-container>
    </div>

    <div class="lm-header-right">
      <app-live-screencast-quota-meter></app-live-screencast-quota-meter>

    <div class="lm-mobile-stats" *ngIf="isMobileUi" role="group" aria-label="Team status summary">
      <button type="button" class="lm-stat-chip" [class.is-active]="isStatusFilterActive('online')" (click)="setStatusFilter('online')">
        {{ employeeCounters.active }} active
      </button>
      <button type="button" class="lm-stat-chip lm-stat-chip--idle" [class.is-active]="isStatusFilterActive('idle')" (click)="setStatusFilter('idle')">
        {{ employeeCounters.idle }} idle
      </button>
      <button type="button" class="lm-stat-chip lm-stat-chip--live" [class.is-active]="isStatusFilterActive('live')" (click)="setStatusFilter('live')">
        {{ st.liveNow }} live
      </button>
    </div>

    <div class="lm-counters segmented-control" *ngIf="!isMobileUi">
      <button
        type="button"
        class="lm-tab segment"
        [class.active]="isStatusFilterActive('online')"
        (click)="setStatusFilter('online')"
        title="Show only active employees">
        Active <strong>{{ employeeCounters.active }}</strong>
      </button>
      <button
        type="button"
        class="lm-tab segment"
        [class.active]="isStatusFilterActive('idle')"
        (click)="setStatusFilter('idle')"
        title="Show only idle employees">
        Idle <strong>{{ employeeCounters.idle }}</strong>
      </button>
      <button
        type="button"
        class="lm-tab segment"
        [class.active]="isStatusFilterActive('offline')"
        (click)="setStatusFilter('offline')"
        title="Show only offline employees">
        Offline <strong>{{ employeeCounters.offline }}</strong>
      </button>
      <button
        type="button"
        class="lm-tab segment"
        [class.active]="isStatusFilterActive('live')"
        (click)="setStatusFilter('live')"
        title="Show only employees currently streaming">
        Live now <strong>{{ st.liveNow }}</strong>
      </button>
    </div>
    </div>
  </div>

  <div class="lm-body">
    <div
      class="lm-left"
      [class.collapsed]="isLeftPaneCollapsed && !isMobileUi"
      [class.lm-mobile-panel-hidden]="!isMobilePanelActive('people')">
      <div class="lm-left-section">
        <div class="lm-left-section-head">
          <div class="lm-left-section-title">{{ isMobileUi ? 'Choose whose desktop to watch' : 'Employees' }}</div>
          <button
            type="button"
            class="lm-pane-toggle"
            *ngIf="!isMobileUi"
            (click)="toggleLeftPane()"
            [attr.aria-label]="isLeftPaneCollapsed ? 'Expand employee panel' : 'Collapse employee panel'"
            [title]="isLeftPaneCollapsed ? 'Expand' : 'Collapse'">
            <span class="material-symbols-outlined">{{ isLeftPaneCollapsed ? 'chevron_right' : 'chevron_left' }}</span>
          </button>
        </div>

        <ng-container *ngIf="!isLeftPaneCollapsed || isMobileUi">
          <div class="lm-left-search">
            <input class="lm-search-input" [(ngModel)]="query" (ngModelChange)="updateQueryParams()" placeholder="Search employees..." />
          </div>

          <div class="lm-left-filters">
            <select class="lm-select browser-default" [(ngModel)]="statusFilter" (ngModelChange)="onDropdownStatusChange()" aria-label="Status filter">
              <option value="all">All status</option>
              <option value="online">Online</option>
              <option value="idle">Idle</option>
              <option value="offline">Offline</option>
              <option value="absent">Absent</option>
              <option value="auto-logout">Auto logout</option>
              <option value="invited">Invited</option>
            </select>
            <select class="lm-select browser-default" [(ngModel)]="teamFilter" (ngModelChange)="updateQueryParams()" aria-label="Team filter">
              <option value="all">All teams</option>
              <option *ngFor="let t of teamOptions" [value]="t">{{ t }}</option>
            </select>
          </div>
          <div class="lm-left-filter-actions">
            <button type="button" class="lm-clear-link" (click)="clearFilters()">Clear filters</button>
          </div>
          <div class="lm-left-badges segmented-control" *ngIf="!isMobileUi">
            <button
              type="button"
              class="lm-tab segment"
              [class.active]="isStatusFilterActive('all')"
              (click)="setStatusFilter('all')"
              title="Show all employees">
              All {{ employeeCounters.active + employeeCounters.idle + employeeCounters.offline }}
            </button>
            <button
              type="button"
              class="lm-tab segment"
              [class.active]="isStatusFilterActive('online')"
              (click)="setStatusFilter('online')"
              title="Show only active employees">
              Active {{ employeeCounters.active }}
            </button>
            <button
              type="button"
              class="lm-tab segment"
              [class.active]="isStatusFilterActive('idle')"
              (click)="setStatusFilter('idle')"
              title="Show only idle employees">
              Idle {{ employeeCounters.idle }}
            </button>
            <button
              type="button"
              class="lm-tab segment"
              [class.active]="isStatusFilterActive('offline')"
              (click)="setStatusFilter('offline')"
              title="Show only offline employees">
              Offline {{ employeeCounters.offline }}
            </button>
          </div>
        </ng-container>

        <div class="lm-left-list">
          <div
            class="lm-emp-row"
            *ngFor="let u of filteredEmployees; trackBy: trackByUserId"
            [class.is-selected]="selectedEmployeeId === u.id"
            [class.is-disabled]="!canRequestScreencast(u)"
            [class.compact]="isLeftPaneCollapsed && !isMobileUi"
            [attr.title]="(u.name || u.display_name || ('User ' + u.id)) + ' • ' + getStatusLabel(u)"
            (click)="selectEmployee(u)">
            <ng-container *ngIf="!isLeftPaneCollapsed || isMobileUi; else compactRow">
              <div class="lm-emp-main">
                <div class="lm-emp-avatar">{{ getEmployeeInitials(u) }}</div>
                <div class="lm-emp-content">
                  <div class="lm-emp-topline">
                    <span class="lm-dot" [class.online]="getStatusDotClass(u)==='online'" [class.idle]="getStatusDotClass(u)==='idle'" [class.offline]="getStatusDotClass(u)==='offline'" [class.invited]="getStatusDotClass(u)==='invited'"></span>
                    <span class="lm-emp-name">{{ u.name || u.display_name || ('User ' + u.id) }}</span>
                    <span
                      *ngIf="showRustAgentBetaBadge(u)"
                      class="agent-beta-badge agent-beta-badge--name"
                      [matTooltip]="sysConfig.rustAgentNameBadgeTooltip"
                      matTooltipPosition="below"
                      (click)="$event.stopPropagation()">{{ sysConfig.rustAgentBetaBadge }}</span>
                    <span class="lm-live-pill" *ngIf="isEmployeeStreaming(u)">Live</span>
                  </div>
                  <div class="lm-emp-meta">{{ getEmployeeStateLine(u) }}</div>
                  <div class="lm-emp-sub">{{ getEmployeeActivityLine(u) }}</div>
                </div>
              </div>
              <button
                type="button"
                class="lm-emp-action-btn"
                [disabled]="!canRequestScreencast(u)"
                (click)="$event.stopPropagation(); onEmployeePrimaryAction(u)">
                {{ mode==='patrol' ? (isInPatrolSelection(u) ? 'Selected' : 'Select') : (isEmployeeStreaming(u) ? 'Live' : getPrimaryActionLabel()) }}
              </button>
            </ng-container>
            <ng-template #compactRow>
              <div class="lm-emp-compact-avatar">{{ getEmployeeInitials(u) }}</div>
              <span class="lm-dot" [class.online]="getStatusDotClass(u)==='online'" [class.idle]="getStatusDotClass(u)==='idle'" [class.offline]="getStatusDotClass(u)==='offline'" [class.invited]="getStatusDotClass(u)==='invited'"></span>
            </ng-template>
          </div>
        </div>
      </div>
    </div>

    <div
      class="lm-right"
      #monitorPanel
      [class.lm-mobile-panel-hidden]="!isMobilePanelActive('stream')">
      <div
        class="lm-stream-chrome"
        [class.lm-stream-chrome--compact]="isMobileUi && (mode === 'single' || mode === 'patrol')"
        [class.lm-stream-chrome--patrol-dense]="mode === 'patrol' && !isMobileUi">
        <div class="lm-console-head">
          <div class="lm-console-top" [class.lm-console-top--patrol]="mode === 'patrol' && !isMobileUi">
            <div class="lm-viewmode">
              <div class="lm-viewmode-label" *ngIf="!isMobileUi && mode !== 'patrol'">View mode</div>
              <div class="lm-viewmode-row">
                <div class="lm-viewmode-tabs segmented-control">
                  <button type="button" class="lm-tab segment" [class.active]="mode==='single'" (click)="setMode('single')">
                    <span class="lm-tab-label-full">Single</span><span class="lm-tab-label-short">Single</span>
                  </button>
                  <button
                    type="button"
                    class="lm-tab segment"
                    [class.active]="mode==='grid'"
                    [class.lm-segment-locked]="isAdvancedLiveModeLocked('grid')"
                    (click)="setMode('grid')"
                    [matTooltip]="isAdvancedLiveModeLocked('grid') ? 'Professional — Live wall' : ''"
                    matTooltipPosition="below">
                    <span class="lm-tab-label-full">Grid</span><span class="lm-tab-label-short">Compare</span>
                    <span *ngIf="isAdvancedLiveModeLocked('grid')" class="lm-segment-lock material-symbols-outlined" aria-hidden="true">lock</span>
                  </button>
                  <button
                    type="button"
                    class="lm-tab segment"
                    [class.active]="mode==='wall'"
                    [class.lm-segment-locked]="isAdvancedLiveModeLocked('wall')"
                    (click)="setMode('wall')"
                    [matTooltip]="isAdvancedLiveModeLocked('wall') ? 'Professional — Live wall' : ''"
                    matTooltipPosition="below">
                    <span class="lm-tab-label-full">Video Wall</span><span class="lm-tab-label-short">Monitor</span>
                    <span *ngIf="isAdvancedLiveModeLocked('wall')" class="lm-segment-lock material-symbols-outlined" aria-hidden="true">lock</span>
                  </button>
                  <button
                    type="button"
                    class="lm-tab segment"
                    [class.active]="mode==='patrol'"
                    [class.lm-segment-locked]="isAdvancedLiveModeLocked('patrol')"
                    (click)="setMode('patrol')"
                    [matTooltip]="isAdvancedLiveModeLocked('patrol') ? 'Professional — Live wall' : ''"
                    matTooltipPosition="below">
                    <span class="lm-tab-label-full">Patrol</span><span class="lm-tab-label-short">Patrol</span>
                    <span *ngIf="isAdvancedLiveModeLocked('patrol')" class="lm-segment-lock material-symbols-outlined" aria-hidden="true">lock</span>
                  </button>
                </div>
                <button
                  *ngIf="isMobileUi"
                  type="button"
                  class="lm-mini-btn lm-fullscreen-btn lm-fs-chip"
                  (click)="toggleMonitorFullscreen()"
                  [attr.aria-label]="isMonitorFullscreen ? 'Exit fullscreen' : 'Enter fullscreen'">
                  <span class="material-symbols-outlined lm-fullscreen-icon">{{ isMonitorFullscreen ? 'fullscreen_exit' : 'fullscreen' }}</span>
                </button>
              </div>
              <div class="lm-viewmode-help" *ngIf="!isMobileUi && mode !== 'patrol'">{{ getModeDescription() }}</div>
            </div>

            <div class="lm-patrol-toolbar" *ngIf="mode==='patrol'">
            <label class="lm-patrol-interval">
              <span class="lm-patrol-interval-label" *ngIf="isMobileUi">Rotate every</span>
              <span class="lm-patrol-interval-label lm-patrol-interval-label--dense" *ngIf="!isMobileUi">Every</span>
              <select
                class="lm-mini-select browser-default"
                [ngModel]="patrolIntervalSec"
                (ngModelChange)="onPatrolIntervalChange($event)"
                aria-label="Patrol interval">
                <option [ngValue]="10">10 sec</option>
                <option [ngValue]="20">20 sec</option>
                <option [ngValue]="30">30 sec</option>
                <option [ngValue]="60">60 sec</option>
              </select>
            </label>
            <div class="lm-patrol-actions" role="group" aria-label="Patrol controls">
              <button *ngIf="showPatrolStart" type="button" class="lm-mini-btn lm-patrol-primary" (click)="startPatrol()">
                <span class="material-symbols-outlined lm-patrol-btn-icon" *ngIf="isMobileUi">play_arrow</span>
                <span class="lm-patrol-btn-text">Start</span>
              </button>
              <button *ngIf="patrolRunning" type="button" class="lm-mini-btn" (click)="pausePatrol()" aria-label="Pause patrol">
                <span class="material-symbols-outlined lm-patrol-btn-icon" *ngIf="isMobileUi">pause</span>
                <span class="lm-patrol-btn-text">Pause</span>
              </button>
              <button *ngIf="showPatrolResume" type="button" class="lm-mini-btn lm-patrol-primary" (click)="resumePatrol()" aria-label="Resume patrol">
                <span class="material-symbols-outlined lm-patrol-btn-icon" *ngIf="isMobileUi">play_arrow</span>
                <span class="lm-patrol-btn-text">Resume</span>
              </button>
              <button *ngIf="showPatrolStepControls" type="button" class="lm-mini-btn" (click)="prevPatrol()" aria-label="Previous employee">
                <span class="material-symbols-outlined lm-patrol-btn-icon" *ngIf="isMobileUi">skip_previous</span>
                <span class="lm-patrol-btn-text">Prev</span>
              </button>
              <button *ngIf="showPatrolStepControls" type="button" class="lm-mini-btn" (click)="nextPatrol()" aria-label="Next employee">
                <span class="material-symbols-outlined lm-patrol-btn-icon" *ngIf="isMobileUi">skip_next</span>
                <span class="lm-patrol-btn-text">Next</span>
              </button>
              <button
                *ngIf="patrolSelectedEmployeeIds.length && !isMobileUi"
                type="button"
                class="lm-mini-btn"
                (click)="clearPatrolSelection()">Clear roster</button>
              <button
                *ngIf="showPatrolStop"
                type="button"
                class="lm-mini-btn danger"
                (click)="stopPatrol(); streamManager.stopStream('patrol','patrol_stopped')"
                aria-label="Stop patrol">
                <span class="material-symbols-outlined lm-patrol-btn-icon" *ngIf="isMobileUi">stop</span>
                <span class="lm-patrol-btn-text">Stop</span>
              </button>
            </div>
            </div>

            <div class="lm-console-top-actions" *ngIf="!isMobileUi">
              <button *ngIf="mode==='wall'" class="lm-mini-btn" (click)="fillWallFromActive()">Fill from active</button>
              <button type="button" class="lm-mini-btn lm-fullscreen-btn" (click)="toggleMonitorFullscreen()">
                {{ isMonitorFullscreen ? 'Exit Fullscreen' : 'Fullscreen' }}
              </button>
            </div>
          </div>

          <div class="lm-mobile-mode-hint" *ngIf="isMobileUi">
            {{ mobileModeHint }}
          </div>

          <button
            *ngIf="isMobileUi && (mode==='wall' || mode==='grid')"
            type="button"
            class="lm-mini-btn lm-wall-fill-mobile"
            (click)="mode==='grid' ? fillGridFromActive() : fillWallFromActive()">
            {{ mode==='grid' ? 'Fill grid from active' : 'Fill from active' }}
          </button>
        </div>

        <div class="lm-patrol-strip" *ngIf="mode==='patrol'" [class.lm-patrol-strip--mobile]="isMobileUi">
        <div class="lm-patrol-strip-row">
          <div
            class="lm-patrol-summary"
            [class.lm-patrol-summary--compact]="!isMobileUi"
            [attr.title]="!isMobileUi ? patrolSummaryText : null">
            {{ isMobileUi ? patrolSummaryText : patrolSummaryCompact }}
          </div>
          <div
            class="lm-patrol-members"
            *ngIf="patrolPoolEmployees.length; else patrolNoMembers"
            role="list"
            aria-label="Patrol roster">
            <span class="lm-patrol-chip" role="listitem" *ngFor="let emp of patrolPoolEmployees; trackBy: trackByUserId">
              {{ emp.name || emp.display_name || ('User ' + emp.id) }}
              <span
                *ngIf="showRustAgentBetaBadge(emp)"
                class="agent-beta-badge agent-beta-badge--name"
                [matTooltip]="sysConfig.rustAgentNameBadgeTooltip"
                matTooltipPosition="below">{{ sysConfig.rustAgentBetaBadge }}</span>
              <button *ngIf="patrolSelectedEmployeeIds.length" type="button" (click)="removeFromPatrolSelection(emp.id)" title="Remove from patrol">×</button>
            </span>
          </div>
        </div>
        <ng-template #patrolNoMembers>
          <div class="lm-patrol-empty">No active employees in patrol roster.</div>
        </ng-template>
        </div>
      </div>

      <div
        class="lm-workspace"
        [class.lm-fill-view]="mode==='single' || mode==='patrol'"
        [class.lm-mobile-stream-stage]="isMobileUi && (mode === 'single' || (mode === 'patrol' && patrolRunning))">
        <ng-container *ngIf="tiles$ | async as tilesMap">
          <!-- SINGLE -->
          <ng-container *ngIf="mode==='single'">
            <ng-container *ngIf="!isModeEmpty(tilesMap); else emptyStateSingle">
              <div class="lm-single">
                <app-live-tile
                  [tile]="tilesMap['single']"
                  (select)="selectTile($event)"
                  [duplicateCount]="streamManager.getActiveTileIdsForEmployee(tilesMap['single']?.employeeId || 0).length"
                  (close)="stopTile($event)"
                  (snapshot)="requestManualSnapshot($event)"
                  (retry)="streamManager.retryTile($event)"></app-live-tile>
              </div>
            </ng-container>
          </ng-container>

          <!-- GRID (always render placeholders) -->
          <div *ngIf="mode==='grid'" class="lm-grid" [class.grid2]="gridSize===2" [class.grid4]="gridSize===4">
            <app-live-tile
              *ngFor="let id of streamManager.gridTileIds(gridSize)"
              [tile]="tilesMap[id]"
              [emptyHint]="getEmptySlotHint()"
              [duplicateCount]="streamManager.getActiveTileIdsForEmployee(tilesMap[id]?.employeeId || 0).length"
              (select)="selectTile($event)"
              (close)="stopTile($event)"
              (snapshot)="requestManualSnapshot($event)"
              (retry)="streamManager.retryTile($event)"></app-live-tile>
          </div>

          <!-- WALL (always render placeholders) -->
          <div *ngIf="mode==='wall'" class="lm-wall">
            <app-live-tile
              *ngFor="let id of streamManager.wallTileIds(16)"
              [tile]="tilesMap[id]"
              [emptyHint]="getEmptySlotHint()"
              [duplicateCount]="streamManager.getActiveTileIdsForEmployee(tilesMap[id]?.employeeId || 0).length"
              (select)="selectTile($event)"
              (close)="stopTile($event)"
              (snapshot)="requestManualSnapshot($event)"
              (retry)="streamManager.retryTile($event)"
              [dense]="true"></app-live-tile>
          </div>

          <!-- PATROL -->
          <ng-container *ngIf="mode==='patrol'">
            <ng-container *ngIf="!isModeEmpty(tilesMap); else emptyStatePatrol">
              <div class="lm-single">
                <app-live-tile
                  [tile]="tilesMap['patrol']"
                  (select)="selectTile($event)"
                  [duplicateCount]="streamManager.getActiveTileIdsForEmployee(tilesMap['patrol']?.employeeId || 0).length"
                  (close)="stopTile($event)"
                  (snapshot)="requestManualSnapshot($event)"
                  (retry)="streamManager.retryTile($event)"></app-live-tile>
              </div>
            </ng-container>
          </ng-container>
        </ng-container>

        <ng-template #emptyStateSingle>
          <div class="lm-empty-state">
            <div class="lm-empty-icon">
              <span class="material-symbols-outlined">desktop_windows</span>
            </div>
            <div class="lm-empty-title">No employee selected</div>
            <p class="lm-empty-text" *ngIf="!isMobileUi">Select an online employee from the left panel to start live monitoring.</p>
            <p class="lm-empty-text" *ngIf="isMobileUi">Tap <strong>Employees</strong> to choose someone online. Their desktop stream will appear here.</p>
            <div class="lm-empty-actions">
              <button type="button" class="lm-mini-btn" *ngIf="isMobileUi" (click)="setMobilePanel('people')">Choose employee</button>
              <button type="button" class="lm-mini-btn lm-mini-btn--secondary" (click)="selectFirstActiveEmployee()">Watch first active</button>
            </div>
          </div>
        </ng-template>

        <ng-template #emptyStatePatrol>
          <div class="lm-empty-state">
            <div class="lm-empty-icon">
              <span class="material-symbols-outlined">play_circle</span>
            </div>
            <div class="lm-empty-title">Patrol is not running</div>
            <div class="lm-empty-text">Start patrol to auto-rotate through active employees.</div>
            <button *ngIf="!isMobileUi" type="button" class="lm-mini-btn" (click)="startPatrol()">Start patrol</button>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
</div>
